import { fetchToken } from "../../common/FetchCookie";
import { ADMIN, ADMIN_REVIEWS, BASE_URL } from "../../common/URLs";

export const fetchAdminReviews = async () => {
    const url = `${BASE_URL}/${ADMIN}/${ADMIN_REVIEWS}`; // Proxy path
    try {
      const token = await fetchToken()

      const response = await fetch(url, {
        method: "GET",
        headers: {
          'Accept': "application/json",
          'Authorization':
            `Bearer ${token}`,
        },
      });
    //   console.log("response", response)
      const data = await response.json();
      return data;
    }catch(error){
        console.log("error", error)
    }
  };

export const deleteAdminReviews = async (uuid) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${ADMIN}/${ADMIN_REVIEWS}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting : " + error.message);
  }
};

